export enum ImagePickerEnums {
  PHOTO = "photo",
  VIDEO = "video",
  MIXED = "mixed",
  FRONT = "front",
  BACK = "back",
  LOW = "low",
  HIGH = "high",
  MEDIUM = "medium",
  PERMISSION = "permission",
  OTHERS = "others",
  CAMERAUNAVAILABLE = "camera_unavailable",
}
